<!-- 生成装车单操作 -->
<template>
   <div>
      <div class="demo-drawer__content data_action_form">
         <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="tabForm">
            <v-tabs :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'" :value="'jciName'" :tabslist="tabForm" @tabs="(val) => { showTabs = val }">
               <template slot="tabs" slot-scope="scope">
                  <!-- 主要信息 -->
                  <div v-if="scope.index == 0" class="table_content_box">
                     <el-form label-width="120px" id="mainInfo" class="baseForm" :model="sendDataInfo" ref="sendDataInfo" size="mini" :show-message="false">
                        <el-row v-if="dataActionBox.actionType != 2">
                           <el-form-item label="订单类型">
                              <el-tag size="mini">{{ sendDataInfo.isCold == 1 ? '冷链' : '普通' }}</el-tag>
                           </el-form-item>
                           <el-form-item v-if="formOneValue.isShow == 1" :label="formOneValue.showField" v-for="(formOneValue, formOneKey) in scope.row.jurconfigform" :key="formOneKey" :prop="formOneValue.entityField"
                                         :rules="formOneValue.isRequired == 1 ? [{ required: true, trigger: ['blur', 'change'] }] : []">
                              <!-- 日期 -->
                              <df-date v-if="formOneValue.fieldType == 'date'" v-model="sendDataInfo[formOneValue.entityField]" @keyup.enter.native="nextFocus(formOneKey)"
                                       :isdisabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2">
                              </df-date>
                              <!-- 普通日期 -->
                              <el-date-picker v-else-if="formOneValue.entityField == 'endDate' || formOneValue.entityField == 'startTem'" @keyup.enter.native="nextFocus(formOneKey)"
                                              v-model="sendDataInfo[formOneValue.entityField]" format="yyyy 年 MM 月 dd 日" value-format="yyyy-MM-dd" style="width:193px" type="date"
                                              :placeholder="'选择' + formOneValue.showField" :isdisabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2">
                              </el-date-picker>
                              <!-- 普通时间 -->
                              <el-time-picker v-model="sendDataInfo[formOneValue.entityField]" style="width:193px" v-else-if="formOneValue.entityField == 'startTime' || formOneValue.entityField == 'endTime'"
                                              format="HH:mm:ss" value-format="HH:mm:ss" :picker-options="{ selectableRange: '00:00:00 - 23:59:59' }" :placeholder="'选择' + formOneValue.showField">
                              </el-time-picker>
                              <!-- 检索方案 -->
                              <el-tooltip v-else-if="formOneValue.fieldType == 'search'" class="item"
                                          :disabled="sendDataInfo[formOneValue.entityField] == null || sendDataInfo[formOneValue.entityField] == '' ? true : false || sendDataInfo[formOneValue.entityField].length <= 9"
                                          effect="dark" :content="sendDataInfo[formOneValue.entityField]" placement="bottom-start">
                                 <el-input clearable v-model="sendDataInfo[formOneValue.entityField]" :ref="formOneValue.entityField" :id="formOneValue.entityField"
                                           @keyup.enter.native="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField, formOneValue.setField)"
                                           :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2">
                                    <el-button @click="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField, formOneValue.setField)" slot="append" icon="el-icon-search"
                                               :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2">
                                    </el-button>
                                 </el-input>
                              </el-tooltip>
                              <el-select clearable @visible-change="selectChange" v-else-if="formOneValue.entityField == 'salesmanType'" @change="changeUnit" :disabled="formOneValue.isChange == 0"
                                         v-model="sendDataInfo[formOneValue.entityField]" placeholder="请选择">
                                 <el-option v-for="item in JSON.parse(formOneValue.formatterContent)" :key="item.key" :label="item.value" :value="item.key">
                                 </el-option>
                              </el-select>
                              <!-- formatter下拉选   :automatic-dropdown="true"-->
                              <el-select clearable size="mini" @visible-change="selectChange" v-else-if="formOneValue.fieldType == 'formatter' && formOneValue.entityField != 'salesmanType'"
                                         :disabled="formOneValue.isChange == 0" @change="$forceUpdate()" v-model="sendDataInfo[formOneValue.entityField]" placeholder="请选择">
                                 <el-option v-for="item in JSON.parse(formOneValue.formatterContent)" :key="item.key" :label="item.value" :value="item.key">
                                 </el-option>
                              </el-select>
                              <el-input @keyup.enter.native="nextFocus(formOneKey)" v-else-if="formOneValue.entityField == 'salesNumber'" :disabled="formOneValue.isChange == 0"
                                        v-model.trim="sendDataInfo[formOneValue.entityField]"></el-input>
                              <!-- string类型 -->
                              <el-input @keyup.enter.native="nextFocus(formOneKey)" v-else :disabled="formOneValue.isChange == 0" v-model.trim="sendDataInfo[formOneValue.entityField]"
                                        :maxlength="$store.state.inputLength"></el-input>
                           </el-form-item>
                        </el-row>
                     </el-form>
                     <div>
                     </div>
                  </div>
               </template>
            </v-tabs>
         </el-card>
         <div class="foot">
            <el-button v-if="dataActionBox.actionType != 2" type="primary" @click="initActionBox('sendDataInfo')">取消</el-button>
            <el-button type="primary" @click="sendDataAction('sendDataInfo')" v-if="dataActionBox.actionType == 0">保存</el-button>
            <el-button type="primary" @click="sendDataAction('sendDataInfo')" v-if="dataActionBox.actionType == 1">保存</el-button>
         </div>
      </div>
      <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth" :modal-append-to-body='true' :append-to-body="true">
         <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
      </el-dialog>
   </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import SearchScheme from "../byComponents/SearchScheme.vue";
export default {
   name: "deliveryPlanAction",
   props: ["actionData"],
   //import引入的组件需要注入到对象中才能使用
   components: {
      SearchScheme,
   },
   data() {
      //这里存放数据
      return {
         mxHeight: 400, //明细表格动态高度
         dataActionBox: {
            showStatus: false,
            openMode: "ltr" || "rtl",
            boxTitle: "新增" || "编辑",
            actionType: 0, // 0新增，1修改
         },
         selectedDataIndex: 0,
         sendDataInfo: {
            deliveryName: "", //	配送员名称
            // dewmuColdAdd: { //	冷链添加信息
            //     coldControl: '', //	温控设备
            //     coldLoadingTem: '', //	装载环境温度
            //     coldRemark: '', //	备注说明
            //     coldStrantem: '', //	启运温度
            //     coldTem: '', //	预冷温度
            //     coldTimeLimit: '', //	保温时限
            //     coldTranmode: '', //	运输方式
            //     coldEndtem: '', //	到货温度
            // },
            driverName: "", //	司机名称
            isCold: 0, //	是否冷链(0:否，1:是)当多个订单如果有一个冷链则是冷链
            loId: "", //	物流公司Id
            companyName: "", //	物流公司
            logisticsMoney: "", //	物流费用
            logisticsNum: "", //	物流单号
            spIds: [], //	发货计划ID
            vmLicensecode: "", //	车牌号
            coldControl: "", //	温控设备
            coldLoadingTem: "", //	装载环境温度
            coldRemark: "", //	备注说明
            coldStrantem: "", //	启运温度
            coldTem: "", //	预冷温度
            coldTimeLimit: "", //	保温时限
            coldTranmode: "", //	运输方式
            coldEndtem: "", //	到货温度
         },
         mainData: [], //普通明细
         detailData: [], //冷链明细
         showTabs: "",
         formDataList: [],
         DialogVisible: false, //检索信息
         seId: "",
         seWidth: "",
         seTitle: "",
         searchType: "",
         parentSearchData: {
            opmDriver: 0,
            opmBuyer: "",
         },

         isLoaded: false,
         isShowDetail: false,
         searchId: "",
         seIndex: 0,
         seType: "",
         sField: "",
         tabForm: [],
         mxForm: [],
         footForm: [],
         inputel: [],
         showTabsId: '',
      };
   },
   //监听属性 类似于data概念
   computed: {},
   //监控data中的数据变化
   watch: {
      "sendDataInfo.deliveryName"() {
         if (this.sendDataInfo.deliveryName == "") {
            this.sendDataInfo.deliveryName = ""
            this.sendDataInfo.driverName = ""
            this.sendDataInfo.vmLicensecode = ""
            this.sendDataInfo.loId = ""
         }
      },
   },
   //生命周期 - 创建完成（可以访问当前this实例）
   created() {
      this.$nextTick(() => {
         var params = this.actionData;
         // console.log(params);
         this.openBox(params.cate, params.formData, params.oldData);
      });
   },
   //方法集合
   methods: {
      // 初始化焦点
      initFocus() {
         for (let index = 0; index < this.inputel.length; index++) {
            if (this.inputel[index].value == "") {
               this.inputel[index].focus();
               break;
            }
         }
      },
      // 输入框切换焦点
      nextFocus(index) {
         if (index >= this.inputel.length - 1) {
            return;
         }
         var aindex = index + 1;
         if (
            this.inputel[aindex].value != "" ||
            this.inputel[aindex].disabled
         ) {
            this.nextFocus(aindex);
            return;
         }
         this.inputel[aindex].focus();
      },
      // 获取主表单所有input
      getMainInput() {
         var el = document.getElementById("mainInfo");
         if (el) this.inputel = el.getElementsByTagName("input");
      },
      // 主表单select框切换enter切换焦点事件方法
      selectChange(e) {
         if (e == false) {
            for (let index = 0; index < this.inputel.length; index++) {
               if (this.inputel[index] == document.activeElement) {
                  this.nextFocus(index);
                  break;
               }
            }
         }
      },
      //
      changeOrder(val) {
         if (val == 0) {
            this.isShowDetail = false;
         } else {
            this.isShowDetail = true;
         }
      },
      //检索Id, 索引(表格中), 标识
      openSearch(sId, index, type, sField) {
         if (this.showTabsId == 11796 && (type == 'driverName' || type == 'vmLicensecode') && (this.sendDataInfo.deliveryName == "" || this.sendDataInfo.deliveryName == null)) {
            return this.$message.error("请先选择物流公司")
         }
         this.DialogVisible = true;
         this.seId = sId;
         this.seIndex = index;
         this.seType = type;
         this.sField = sField;
         for (const key in this.sendDataInfo) {
            if (this.sendDataInfo[key]) {
               this.parentSearchData[key] = this.sendDataInfo[key];
            }
         }
         if (type == 'deliveryName') {
            this.parentSearchData.opmName = this.sendDataInfo.deliveryName
         }
         if (type == 'driverName') {
            this.parentSearchData.opmName = this.sendDataInfo.driverName
         }
         this.parentSearchData.opmDriver = type == "driverName" ? 1 : "";
         this.parentSearchData.opmDistributor = type == "driverName" ? "" : 1;
      },
      // 赋值字段
      paramValue(val) {
         let arr = this.sField.split(",");
         arr.forEach((item) => {
            this.sendDataInfo[item] = val[item];
         });
         this.$nextTick(() => {
            this.nextFocus(this.seIndex);
         });
      },
      //提取返回
      changeInputModel(val) {
         console.log("返回", val);
         if (val != "" || val != undefined) {
            this.DialogVisible = false;
            this.paramValue(val);
         } else {
            this.$message({
               message: "检索信息失败",
               type: "warning",
            });
         }
      },
      getSeWidth(e) {
         this.seWidth = e + "%";
      },
      getSearchName(e) {
         this.seTitle = e;
      },

      //确认新增
      sendDataAction(formName) {
         this.$refs[formName].validate((valid) => {
            if (valid) {
               // console.log('sendDataInfo',this.sendDataInfo);
               this.sub();
            } else {
               this.$message({
                  message: "请完善信息",
                  type: "error",
               });
               return false;
            }
         });
      },
      async sub() {
         console.log(this.showTabsId == 11796);
         var responseData;
         if (this.showTabsId == 11796) {
            responseData = await this.$http.addLogisticsLoading(
               this.sendDataInfo
            );
            if (responseData.status == 200) {
               this.$message({
                  message: "操作成功",
                  type: "success",
               });
               this.$emit("drawerCancel", true);
            } else {
               this.$message({
                  message: responseData.message,
                  type: "error",
               });
            }

         } else {
            if (this.dataActionBox.actionType == 0) {
               responseData = await this.$http.shipPlanLoadingAdd(
                  this.sendDataInfo
               );
            } else {
               responseData = await this.$http.setTransportdocAdd(
                  this.sendDataInfo
               );
            }
            if (responseData.status == 200) {
               this.$message({
                  message: "操作成功",
                  type: "success",
               });
               this.$emit("drawerCancel", true);
            } else {
               this.$message({
                  message: responseData.message,
                  type: "error",
               });
            }
         }

      },
      //取消
      initActionBox(formName) {
         var cancelTitle = this.dataActionBox.actionType == 0 ? "新增" : "修改";
         this.$confirm("确定取消" + cancelTitle + "吗?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
         })
            .then(() => {
               this.$emit("drawerCancel");
               this.init();
               this.$refs[formName].resetFields();
            })
            .catch(() => { });
      },
      //初始化
      init() {
         for (let key in this.sendDataInfo) {
            if (key == "dewmuColdAdd") {
               for (let sonOne in this.sendDataInfo[key]) {
                  if (sonOne == "coldArrtime" || sonOne == "coldStrantime") {
                     this.sendDataInfo[key][sonOne] = this.$moment().valueOf();
                  } else {
                     this.sendDataInfo[key][sonOne] = "";
                  }
               }
            } else if (key == "isCold" || key == "isTripartite") {
               this.sendDataInfo[key] = 0;
            } else {
               this.sendDataInfo[key] = "";
            }
         }
         this.sendDataInfo.spIds = [];
      },
      //父级传入
      openBox(cate, formData, oldData = "") {
         this.showTabs = "生成装车单"; //formData[0].jciName;
         this.formDataList = formData;
         this.filterMainField();
         if (cate == 0) {
            this.dataActionBox.boxTitle = "新增信息";
            this.dataActionBox.openMode = "ltr";
            var dataInfo = JSON.parse(JSON.stringify(oldData));

            dataInfo.forEach((v) => {
               this.sendDataInfo.spIds.push(v.spId);
               if (v.orderType == 1) this.sendDataInfo.isCold = 1;
            });
            this.sendDataInfo.companyName = dataInfo[0].companyName;
            this.sendDataInfo.loId = dataInfo[0].loId;
            this.sendDataInfo.deliveryName = dataInfo[0].deliveryName || '';
            this.sendDataInfo.driverName = dataInfo[0].driverName || '';
            this.sendDataInfo.vmLicensecode = dataInfo[0].vmLicensecode || '';
         } else if (cate == 1) {
            this.dataActionBox.boxTitle = "编辑信息";
            this.dataActionBox.openMode = "rtl";
         }
         this.$nextTick(() => {
            this.initFocus();
         });
         this.dataActionBox.actionType = cate
      },
      //换行提示
      lineMessageBox(data) {
         let txtArr = data.message.split("<br/>");
         let newArr = [];
         const h = this.$createElement;
         for (const i in txtArr) {
            newArr.push(h("p", null, txtArr[i]));
         }
         this.$alert(h("div", null, newArr), "提示", {
            confirmButtonText: "确定",
            callback: (action) => { },
         });
      },
      // 过滤表单不同类型
      filterMainField() {
         var mainFormList = [];
         this.formDataList.forEach((item) => {
            if (item && item.jciType == 1) {
               mainFormList.push(item);
            } else if (item && item.jciType == 2) {
               this.mxForm = JSON.parse(JSON.stringify(item));
            } else if (item && item.jciType == 3) {
               this.footForm = JSON.parse(JSON.stringify(item.jurconfigform));
            }
         });
         mainFormList.forEach((key, i) => {
            this.tabForm[i] = JSON.parse(JSON.stringify(key));
            this.tabForm[i].jurconfigform = [];
            for (let index = 0; index < key.jurconfigform.length; index++) {
               if (key.jurconfigform[index].isShow == 1)
                  this.tabForm[i].jurconfigform.push(key.jurconfigform[index]);
            }
            console.log(this.tabForm);
         });
         var arr = [{ entityField: "spIds" }]
         var obj = this.$common.filterMainFields(this.formDataList, arr, mainFormList[0])
         for (let key in obj) {
            if (key == 'isCold') {
               this.$set(this.sendDataInfo, key, 0)
            } else {
               this.$set(this.sendDataInfo, key, obj[key])
               this.sendDataInfo.coldEndtem = "";
            }
         }
         this.showTabs = this.tabForm[0].jciName;
         this.showTabsId = this.tabForm[0].jciId;

      },
   },
   //生命周期 - 挂载完成（可以访问DOM元素）
   mounted() { },
   beforeCreate() { }, //生命周期 - 创建之前
   beforeMount() { }, //生命周期 - 挂载之前
   beforeUpdate() { }, //生命周期 - 更新之前
   updated() {
      this.getMainInput();
   }, //生命周期 - 更新之后
   beforeDestroy() { }, //生命周期 - 销毁之前
   destroyed() { }, //生命周期 - 销毁完成
   activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style scoped>
.table_button_box {
   height: 200px;
   background-color: red;
}

.table_content_box {
   /* height: 500px !important; */
   overflow-y: auto;
}

.el-row {
   display: flex;
   flex-wrap: wrap;
   padding-right: 20px;
}

.el-drawer {
   outline: none;
}
</style>
